module.exports = __webpack_public_path__ + "img/insight_logo.4c80f58c.svg";